import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { collection, addDoc, doc, updateDoc, getDoc } from 'firebase/firestore';


const MemberForm = ({ itemData, onClose }) => {
    const [lastName, setLastName] = useState('');
    const [firstName, setFirstName] = useState('');
    const [position, setPosition] = useState('');
    const [profilePicture, setProfilePicture] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [cloudinaryConfig, setCloudinaryConfig] = useState(null);

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setProfilePicture(e.target.files[0]);
        }
    };


    useEffect(() => {
        const fetchCloudinaryConfig = async () => {
            try {
                const configRef = doc(db, 'config', 'cloudinary');
                const configSnap = await getDoc(configRef);
                if (configSnap.exists() && configSnap.data().cloud_name && configSnap.data().upload_preset) {
                    setCloudinaryConfig(configSnap.data());
                } else {
                    setError('Cloudinary konfigurácia nebola nájdená alebo je nekompletná. Prosím, nastavte ju.');
                }
            } catch (err) {
                console.error("Error fetching Cloudinary config:", err);
                setError('Nepodarilo sa načítať Cloudinary konfiguráciu.');
            }
        };

        fetchCloudinaryConfig();
        setError(null);
        if (itemData) {
            setFirstName(itemData.firstName || '');
            setLastName(itemData.lastName || '');
            setPosition(itemData.position || '');

        }

    }, [itemData]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(false);

        if (!cloudinaryConfig) {
            setError("Cloudinary konfigurácia sa nenačítala. Nahrávanie súboru nie je možné.");
            setLoading(false);
            return;
        }

        try {
            let profilePictureUrl = itemData?.profilePictureUrl || null;

            if (profilePicture) {
                const formData = new FormData();
                formData.append('file', profilePicture);
                formData.append('upload_preset', cloudinaryConfig.upload_preset);


                try {
                    const response = await fetch(`https://api.cloudinary.com/v1_1/${cloudinaryConfig.cloud_name}/image/upload`, {
                        method: 'POST',
                        body: formData,
                    });

                    const data = await response.json();

                    if (response.ok) {
                        profilePictureUrl = data.secure_url;
                    } else {
                        console.error('Cloudinary upload error:', data.error || response.statusText);
                        setError(data.error?.message || 'Nepodařilo se nahrát fotku na Cloudinary.');
                        setLoading(false);
                        return;
                    }
                } catch (uploadError) {
                    console.error('Cloudinary fetch error:', uploadError);
                    setError('Chyba při komunikaci s Cloudinary.');
                    setLoading(false);
                    return;
                }
            } else if (!itemData) {
            }
            if (itemData) {
                const memberDoc = doc(db, 'members', itemData.id);
                const updatedData = {
                    firstName: firstName,
                    lastName: lastName,
                    position: position,
                };
                if (profilePictureUrl !== null) {
                    updatedData.profilePictureUrl = profilePictureUrl;
                }
                await updateDoc(memberDoc, updatedData);
            } else {
                // Add new member
                await addDoc(collection(db, 'members'), {
                    firstName: firstName,
                    lastName: lastName,
                    position: position,
                    profilePictureUrl: profilePictureUrl,
                    createdAt: new Date()
                });
            }

            setSuccess(true);
            if (!itemData) {
                setFirstName('');
                setLastName('');
                setPosition('');
                setProfilePicture(null);
            }
            setLoading(false);

        } catch (err) {
            console.error("Unexpected error:", err);
            setError('An unexpected error occurred.');
            setLoading(false);
        }
    };

    return (
        <div className="container mx-auto p-4 text-gray-800">
            <h2 className="text-2xl font-bold mb-4">{itemData ? 'Upravit Člena' : 'Přidat Člena'}</h2>
            <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md">
                <div className="mb-4">
                    <label htmlFor="firstName" className="block text-gray-700 text-sm font-bold mb-2">
                        Jméno:
                    </label>
                    <input
                        type="text"
                        id="firstName"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="lastName" className="block text-gray-700 text-sm font-bold mb-2">
                        Příjmení:
                    </label>
                    <input
                        type="text"
                        id="lastName"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="position" className="block text-gray-700 text-sm font-bold mb-2">
                        Pozice:
                    </label>
                    <input
                        type="text"
                        id="position"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        value={position}
                        onChange={(e) => setPosition(e.target.value)}
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="profilePicture" className="block text-gray-700 text-sm font-bold mb-2">
                        Profilová fotka:
                    </label>
                    <input
                        type="file"
                        id="profilePicture"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        onChange={handleFileChange}
                        accept="image/*"
                        required={!itemData || profilePicture}
                    />
                </div>
                {error && (
                    <p className="text-red-500 text-sm italic mb-4">{error}</p>
                )}
                {success && (
                    <p className="text-green-500 text-xs italic mb-4">{itemData ? 'Člen byl úspěšně aktualizován!' : 'Člen byl úspěšně přidán!'}</p>
                )}
                <div className="flex items-center justify-between">
                    <button
                        type="submit"
                        className="bg-blue-600 hover:bg-blue-800 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline disabled:opacity-50 transition duration-300"
                        disabled={loading}
                    >
                        {loading ? (itemData ? 'Ukládám...' : 'Přidávám...') : (itemData ? 'Uložit Změny' : 'Přidat Člena')}
                    </button>
                    {onClose && (
                        <button type="button" onClick={onClose} className="ml-4 text-gray-600 hover:text-gray-800">Zrušit</button>
                    )}
                </div>
            </form>
        </div>
    );
};

export default MemberForm;